import { AxiosResponse } from "axios";
import { microserviceApiAxios } from "../../microservice-api.axios";
import { microserviceApiRoutes } from "../../microservice-api.routes";

export const authAgentGetMe = () => {
  const url = microserviceApiRoutes.v1.agents.user.me();
  return microserviceApiAxios.get(url).then((res) => res.data);
};

export const authAgentsChangePassword = (data: any) => {
  const url = microserviceApiRoutes.v1.agents.auth.changePassword();
  return microserviceApiAxios.post(url, data).then((res) => res.data);
};
